import { useContext } from 'react'
import { Button, Toast } from '@vzmi/shp_shared_compo'
import { useQueryString } from '@vzmi/shp_shared_compo/dist/hook/useQueryString.js'
import { PROPOSAL_TYPE } from '@vzmi/shp_shared_compo/dist/constants/proposal.js'
import { PAGE_FLOW } from '../../../../constants/proposalTypes'
import {
  FlowContext,
  defaultPassedFlow
} from '../../helper/flow'
import usePageFlow from '../../hook/usePageFlow'
import styles from './index.css'
import { getUpdateListingPreviewPage } from '../../../Proposal/Common/ProposalForm/Shared/util'
import { HyperLink } from '../../../Common/Form'
import HeadingWithId from '../../../Proposal/Common/HeadingWithId/HeadingWithId'

const ActionHeader = props => {
  const {
    children,
    title,
    subtitle,
    listingIds,
    onReturnEdit = defaultPassedFlow,
    isBatchProposal = true,
    proposalType = ''
  } = props
  const {
    phase,
    pageFlow,
    setPageFlow,
    setIsPending
  } = useContext(FlowContext)
  const proposalId = useQueryString(props, 'id', true)

  const onProposalReturnEdit = async () => {
    setIsPending(true)
    const [errorMessage, isPassed] = await onReturnEdit()
    setIsPending(false)
    if (!isPassed) {
      errorMessage && Toast.error(errorMessage)
      return
    }
    const queryKey = isBatchProposal ? 'listingIds' : 'listingId'
    // 返回編輯後更新 querystring 成賣場編號
    window.history.pushState('', '', `${window.location.pathname}?${queryKey}=${listingIds}`)
    setPageFlow(PAGE_FLOW.EDIT)
  }

  const { isConfirmPage } = usePageFlow(phase, pageFlow)
  const listingPreviewUri = getUpdateListingPreviewPage(proposalId, proposalType)

  return (
    <div
      className={styles.actionHeader}
      data-role='action-header'
    >
      <HeadingWithId
        title={title}
        subtitle={subtitle}
      />
      {
        isConfirmPage && (
          <div
            className={styles.backToEditBtn}
          >
            {
              (!isBatchProposal && proposalType === PROPOSAL_TYPE.UPDATE_LISTING) && (
                <HyperLink
                  target='_blank'
                  href={listingPreviewUri}
                  isButton
                >
                  <Button
                    data-role='listing-preview'
                    size='large'
                  >
                    賣場預覽
                  </Button>
                </HyperLink>
              )
            }
            <Button
              data-role='back-to-edit-button'
              size='large'
              buttonType='outline'
              onClick={onProposalReturnEdit}
            >
              返回編輯
            </Button>
          </div>
        )
      }
      {children}
    </div>
  )
}

export default ActionHeader
